import React from 'react';
import fetch from 'cross-fetch';

import InvoiceSearch from './InvoiceSearch';
import { fetchAccountOrganizationOptions } from "./SharedServiceCalls";

import { printCurrency, printDate, formatAddress } from '../util/formatUtility';
import { addResourceStrings, translateResourceString } from '../util/translationUtility';
import { MessagesList, ERROR_USER_ALERT } from '../SharedComponents/UserMessaging/';
import invoiceEventBusClient from "../util/invoiceEventBusClient";

let messageId = 0;
const createUserMessage = ({ text, type }) => ({ id: messageId++, text, type });

class InvoiceHistoryApp extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            accountOrganizationOptions: [],
            selectedAccountOrganizationOption: null,
            userMessages: [],
            invoicePayments: []
        };

        addResourceStrings(props.LocalizationItems);
    }

    async componentDidMount() {
        var accountsAndOrganizationsResponse = await fetchAccountOrganizationOptions(this.props.GetAccountsAndOrganizationsOptionsEndpoint);
        if (accountsAndOrganizationsResponse.success) {
            this.setState( { accountOrganizationOptions: accountsAndOrganizationsResponse.options,
                                  selectedAccountOrganizationOption: accountsAndOrganizationsResponse.options.length > 0 
                                  ? accountsAndOrganizationsResponse.options[0] : null});
        } else {
            if (accountsAndOrganizationsResponse.message) {
                this.addMessage(accountsAndOrganizationsResponse.message);
            }
        }
    
        invoiceEventBusClient.on("paymentProcessed", () => 
        {
            if(this.state.selectedAccountOrganizationOption != null){
                this.fetchInvoicePaymentHistory(this.state.selectedAccountOrganizationOption);
            }
        });   
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedAccountOrganizationOption !== this.state.selectedAccountOrganizationOption) {
            if (!!this.state.selectedAccountOrganizationOption) {
                this.fetchInvoicePaymentHistory(this.state.selectedAccountOrganizationOption);
            } else {
                this.setState({ allInvoices: [] });
            }
        }
    }

    componentWillUnmount() {
        invoiceEventBusClient.remove("paymentProcessed");
    }

    fetchInvoicePaymentHistory = (option) => {

        var fetchUrl = this.props.GetInvoicePaymentHistoryForAccountEndpoint + "?accountId=" + option.AccountId;
        if (!option.AccountId) {
            fetchUrl = this.props.GetInvoicePaymentHistoryForOrganizationEndpoint + "?organizationId=" + option.OrganizationId;
        }

        fetch(
            fetchUrl,
            {
                headers: {
                    'content-type': 'application/json',
                    'X-Requested-With': 'fetch'
                },
                credentials: 'same-origin',
            }
        )
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    if (typeof console !== 'undefined' && console.log) {
                        console.error(response);
                    }
                    throw new Error()
                }
            })
            .then(data => {
                if (!data || !data.invoicePayments) {
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(data);
                    }
                    throw new Error("Invalid data format");
                }
                this.setState(prevState => {
                    return { invoicePayments: data.invoicePayments };
                });
            })
            .catch(() => {
                this.setState(prevState => ({
                    userMessages: prevState.userMessages.concat([
                        createUserMessage({
                            text: translateResourceString("/MyAccountPage/InvoicePayments/ErrorLoadingInvoices"),
                            type: ERROR_USER_ALERT
                        })
                    ])
                }));
            });
    }

    addMessage = ({ text, type }) => {
        this.setState(prevState => ({
            userMessages: prevState.userMessages.concat([
                createUserMessage({
                    text: text,
                    type: type
                })
            ])
        }))
    }

    onDismissMessage = (id) => {
        this.setState(prevState => ({
            userMessages: prevState.userMessages
                ? prevState.userMessages.filter((message) => message.id !== id)
                : []
        }));
    }

    render() {
        const {
            accountOrganizationOptions,
            selectedAccountOrganizationOption,
            userMessages,
            invoicePayments
        } = this.state;

        const {
        } = this.props;

        //const invoicesRender = invoices.map((x, i, y) => this.renderInvoice(i), this);

        return (
            <React.Fragment>
                <MessagesList
                    messages={userMessages}
                    onDismiss={this.onDismissMessage}
                />
                <InvoiceSearch
                    accountOrganizationOptions={accountOrganizationOptions}
                    selectedAccountOrganizationOption={selectedAccountOrganizationOption}
                    setSelectedAccountOrganization={(option) => { this.setState({ selectedAccountOrganizationOption: option }); }}
                />
                <div className="input-container">
                    <div className="table-responsive">
                        <table className="table invoice-table text-sm">
                            <thead>
                                <tr>
                                    <th scope="col">&nbsp;</th>
                                    <th scope="col">{translateResourceString("/MyAccountPage/InvoicePayments/History/PaymentNumberHeading")}</th>
                                    <th scope="col">{translateResourceString("/MyAccountPage/InvoicePayments/History/BillToHeading")}</th>
                                    <th scope="col">{translateResourceString("/MyAccountPage/InvoicePayments/History/CustomerNameAddressHeading")}</th>
                                    <th scope="col">{translateResourceString("/MyAccountPage/InvoicePayments/History/PaidDateHeading")}</th>
                                    <th scope="col">{translateResourceString("/MyAccountPage/InvoicePayments/History/SurchargeHeading")}</th>
                                    <th scope="col">{translateResourceString("/MyAccountPage/InvoicePayments/History/TotalPaidHeading")}</th>
                                    <th scope="col">{translateResourceString("/MyAccountPage/InvoicePayments/History/PaymentMethodHeading")}</th>

                                </tr>
                            </thead>
                            <tbody>
                                {invoicePayments.map((p, i) =>
                                    <React.Fragment key={p.InvoicePaymentId}>
                                        <tr data-toggle="collapse" data-target={("#payment-details-" + p.InvoicePaymentId)} className="accordion-toggle">
                                            <td><button className="btn btn-link" style={{ color: "inherit" }}><i className="fas fa-caret-right"></i></button></td>
                                            <td>{p.InvoicePaymentId}</td>
                                            <td>{p.PayerId}</td>
                                            <td>{p.CustomerName}<br />{formatAddress(p.Address)}</td>
                                            <td>{printDate(p.PaymentDateDisplay)}</td>
                                            <td>{printCurrency(p.Surcharge)}</td>
                                            <td>{printCurrency(p.Total)}</td>
                                            <td>{p.PaymentMethod}</td>
                                        </tr>
                                        <tr className="invoice-payment-details">
                                            <td colSpan="8" id={("payment-details-" + p.InvoicePaymentId)} className="accordian-body collapse">
                                                <div className="table-responsive">
                                                    <table className="table table-striped" >
                                                        <thead>
                                                            <th scope="col">{translateResourceString("/MyAccountPage/InvoicePayments/History/CustomerNumberHeading")}</th>
                                                            <th scope="col">{translateResourceString("/MyAccountPage/InvoicePayments/History/CustomerNameAddressHeading")}</th>
                                                            <th scope="col">{translateResourceString("/MyAccountPage/InvoicePayments/History/AddlReferenceNumberHeading")}</th>
                                                            <th scope="col">{translateResourceString("/MyAccountPage/InvoicePayments/History/AmountPaidHeading")}</th>
                                                        </thead>
                                                        <tbody>
                                                            <tr className="d-none"></tr> {/* This changes the color alternations to have light first */}
                                                            {p.Details.map((d, di) =>
                                                                <tr key={p.InvoicePaymentId + "-" + d.InvoicePaymentDetailId}>
                                                                    <td>{d.CustomerNumber}</td>
                                                                    <td>{d.CustomerName}<br />{formatAddress(d.Address)}</td>
                                                                    <td><a href={d.PdfUrl} target="blank">{d.AddlReferenceNumber}</a></td>
                                                                    <td>{printCurrency(d.Amount)}</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </React.Fragment >
        );
    }
}

export default InvoiceHistoryApp;